module.exports = __webpack_public_path__ + "img/documento.bb8c9ca7.png";